/*
 * Free shipping bar (snippets/rs-free-shipping-bar.liquid): Dawn renders the cart drawer again
 * after every cart change, so each new <rs-free-shipping> starts from the width of the previous
 * one and grows (or shrinks) to its own value.
 */
if (!customElements.get('rs-free-shipping')) {
  let lastPct = 0;

  customElements.define(
    'rs-free-shipping',
    class RsFreeShipping extends HTMLElement {
      connectedCallback() {
        const fill = this.querySelector('.rs-fs__fill');
        const pct = Math.min(100, parseFloat(this.dataset.pct) || 0);
        if (!fill) return;
        fill.style.transition = 'none';
        fill.style.width = `${lastPct}%`;
        fill.getBoundingClientRect();
        fill.style.transition = '';
        requestAnimationFrame(() => (fill.style.width = `${pct}%`));
        lastPct = pct;
      }
    }
  );
}
